import { render } from "./BlogPostBreadcrumb.vue?vue&type=template&id=6120f8e6"
import script from "./BlogPostBreadcrumb.vue?vue&type=script&lang=js"
export * from "./BlogPostBreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__